import {
    FETCH_SETTLEMENT_REQUEST,
    FETCH_SETTLEMENT_SUCCESS,
    FETCH_SETTLEMENT_ERROR,
    HIDE_SETTLEMENT_LOADER,
    SHOW_SETTLEMENT_LOADER,
    FETCH_SETTLEMENT_METRICS_REQUEST,
    FETCH_SETTLEMENT_METRICS_SUCCESS,
    FETCH_SETTLEMENT_METRICS_ERROR,
    RETRY_SETTLEMENT_REQUEST,
    RETRY_SETTLEMENT_SUCCESS,
    RETRY_SETTLEMENT_ERROR,
    RETRIGGER_SETTLEMENT_REQUEST,
    RETRIGGER_SETTLEMENT_SUCCESS,
    RETRIGGER_SETTLEMENT_ERROR,
    FETCH_AVAILABLE_BALANCE_REQUEST,
    FETCH_AVAILABLE_BALANCE_SUCCESS,
    FETCH_AVAILABLE_BALANCE_ERROR,
    FETCH_ODS_FEE_DETAILS_REQUEST,
    FETCH_ODS_FEE_DETAILS_SUCCESS,
    FETCH_ODS_FEE_DETAILS_ERROR,
    PROCESS_ODS_REQUEST,
    PROCESS_ODS_SUCCESS,
    PROCESS_ODS_ERROR,
    SET_AVAILABLE_BALANCE_LOADING,
    REMOVE_AVAILABLE_BALANCE_LOADING,
    SET_ODS_PAGE_LOADING,
    REMOVE_ODS_PAGE_LOADING,
    SET_PROCESS_LOADING,
    REMOVE_PROCESS_LOADING,
    GET_MERCHANT_SECTION_INFO_REQUEST,
    FETCH_NET_SETTLEMENT_REQUEST,
    FETCH_NET_SETTLEMENT_SUCCESS,
    FETCH_NET_SETTLEMENT_ERROR,
} from './settlement.constants';

export const fetchSettlementRequest = payload => ({
    type: FETCH_SETTLEMENT_REQUEST,
    payload,
});

export const fetchSettlementSuccess = payload => ({
    type: FETCH_SETTLEMENT_SUCCESS,
    payload,
});

export const fetchSettlementError = payload => ({
    type: FETCH_SETTLEMENT_ERROR,
    payload,
});

export const fetchSettlementMetricsRequest = payload => ({
    type: FETCH_SETTLEMENT_METRICS_REQUEST,
    payload,
});

export const fetchSettlementMetricsSuccess = payload => ({
    type: FETCH_SETTLEMENT_METRICS_SUCCESS,
    payload,
});

export const fetchSettlementMetricsError = payload => ({
    type: FETCH_SETTLEMENT_METRICS_ERROR,
    payload,
});

export const retrySettlementRequest = payload => ({
    type: RETRY_SETTLEMENT_REQUEST,
    payload,
});

export const retrySettlementSuccess = payload => ({
    type: RETRY_SETTLEMENT_SUCCESS,
    payload,
});

export const retrySettlementError = payload => ({
    type: RETRY_SETTLEMENT_ERROR,
    payload,
});

export const retriggerSettlementRequest = payload => ({
    type: RETRIGGER_SETTLEMENT_REQUEST,
    payload,
});

export const retriggerSettlementSuccess = payload => ({
    type: RETRIGGER_SETTLEMENT_SUCCESS,
    payload,
});

export const retriggerSettlementError = payload => ({
    type: RETRIGGER_SETTLEMENT_ERROR,
    payload,
});

export const fetchAvailableBalanceRequest = payload => ({
    type: FETCH_AVAILABLE_BALANCE_REQUEST,
    payload,
});

export const fetchAvailableBalanceSuccess = payload => ({
    type: FETCH_AVAILABLE_BALANCE_SUCCESS,
    payload,
});

export const fetchAvailableBalanceError = payload => ({
    type: FETCH_AVAILABLE_BALANCE_ERROR,
    payload,
});

export const fetchNetSettlementRequest = payload => ({
    type: FETCH_NET_SETTLEMENT_REQUEST,
    payload,
});

export const fetchNetSettlementSuccess = payload => ({
    type: FETCH_NET_SETTLEMENT_SUCCESS,
    payload,
});

export const fetchNetSettlementError = payload => ({
    type: FETCH_NET_SETTLEMENT_ERROR,
    payload,
});

export const fetchOdsDetailsRequest = (payload, handleSuccess) => ({
    type: FETCH_ODS_FEE_DETAILS_REQUEST,
    payload,
    handleSuccess,
});

export const fetchOdsDetailsSuccess = payload => ({
    type: FETCH_ODS_FEE_DETAILS_SUCCESS,
    payload,
});

export const fetchOdsDetailsError = payload => ({
    type: FETCH_ODS_FEE_DETAILS_ERROR,
    payload,
});
export const fetchProcessOdsRequest = (payload, handleSuccess) => ({
    type: PROCESS_ODS_REQUEST,
    payload,
    handleSuccess,
});

export const fetchProcessOdsSuccess = payload => ({
    type: PROCESS_ODS_SUCCESS,
    payload,
});

export const fetchProcessOdsError = payload => ({
    type: PROCESS_ODS_ERROR,
    payload,
});

export const setAvailableBalanceLoader = () => ({
    type: SET_AVAILABLE_BALANCE_LOADING,
});

export const removeAvailableBalanceLoader = () => ({
    type: REMOVE_AVAILABLE_BALANCE_LOADING,
});

export const setODSPageLoader = () => ({
    type: SET_ODS_PAGE_LOADING,
});

export const removeODSPageLoader = () => ({
    type: REMOVE_ODS_PAGE_LOADING,
});

export const setProcessLoader = () => ({
    type: SET_PROCESS_LOADING,
});

export const removeProcessLoader = () => ({
    type: REMOVE_PROCESS_LOADING,
});

export const getMerchantSectionInfoRequest = (
    payload,
) => ({
    type: GET_MERCHANT_SECTION_INFO_REQUEST,
    payload,
});

export const showLoader = () => ({ type: SHOW_SETTLEMENT_LOADER });

export const hideLoader = () => ({ type: HIDE_SETTLEMENT_LOADER });
